import CountdownIcon from "@marketing-site/static/icons/countdown.png";
import { media, theme } from "@marketing-site/styles";
import { IStyledIsSaleLive } from "@marketing-site/types";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

const SmallCountdownIcon = (props: IStyledIsSaleLive) => {
  const fillColor = props.isSaleLive
    ? theme.colors.yellow
    : theme.colors.skyblue;

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3333 7.99231C15.3358 9.17698 15.0506 10.3446 14.5022 11.395C13.9538 12.4454 13.1586 13.3472 12.1848 14.0233C11.2109 14.6993 10.0875 15.1293 8.91081 15.2764C7.73411 15.4236 6.53924 15.2834 5.42865 14.8681C4.31806 14.4527 3.32488 13.7744 2.53425 12.8914C1.74363 12.0085 1.17916 10.9471 0.889224 9.79841C0.599293 8.6497 0.592555 7.44788 0.869587 6.29599C1.14662 5.1441 1.69916 4.07651 2.47983 3.18475H1.85815C1.67581 3.18475 1.50094 3.11239 1.37201 2.98359C1.24308 2.85479 1.17065 2.6801 1.17065 2.49796C1.17065 2.31581 1.24308 2.14112 1.37201 2.01232C1.50094 1.88352 1.67581 1.81116 1.85815 1.81116H4.14981C4.33214 1.81121 4.50698 1.88358 4.6359 2.01237C4.76482 2.14116 4.83727 2.31582 4.83731 2.49796V4.78727C4.83731 4.96942 4.76488 5.14411 4.63595 5.27291C4.50702 5.40171 4.33215 5.47407 4.14981 5.47407C3.96748 5.47407 3.79261 5.40171 3.66368 5.27291C3.53475 5.14411 3.46231 4.96942 3.46231 4.78727V4.14793C2.58735 5.18235 2.09217 6.48422 2.05874 7.83807C2.0253 9.19192 2.45561 10.5166 3.27845 11.5929C4.10129 12.6691 5.26733 13.4325 6.58359 13.7566C7.89986 14.0806 9.28744 13.946 10.5167 13.375C11.746 12.804 12.7432 11.8308 13.3434 10.6165C13.9436 9.40221 14.1107 8.01958 13.8172 6.69745C13.5236 5.37531 12.7869 4.19294 11.7291 3.34601C10.6713 2.49908 9.35565 2.03835 8 2.04009C7.81766 2.04009 7.64279 1.96773 7.51386 1.83894C7.38493 1.71014 7.3125 1.53545 7.3125 1.3533C7.3125 1.17115 7.38493 0.99646 7.51386 0.867661C7.64279 0.738862 7.81766 0.666504 8 0.666504C9.94424 0.668726 11.8082 1.44126 13.183 2.81464C14.5578 4.18801 15.3311 6.05007 15.3333 7.99231ZM9.1606 9.89083C9.22959 9.94915 9.30941 9.99332 9.39549 10.0208C9.48158 10.0483 9.57225 10.0585 9.66231 10.051C9.75237 10.0435 9.84006 10.0182 9.92036 9.97682C10.0007 9.93539 10.072 9.87855 10.1303 9.80956C10.1886 9.74057 10.2327 9.66078 10.2601 9.57474C10.2875 9.48871 10.2977 9.39812 10.29 9.30816C10.2823 9.21821 10.257 9.13064 10.2154 9.05048C10.1738 8.97031 10.1168 8.89912 10.0477 8.84097L8.6875 7.6972V5.0162C8.6875 4.83405 8.61506 4.65936 8.48613 4.53057C8.3572 4.40177 8.18233 4.32941 8 4.32941C7.81766 4.32941 7.64279 4.40177 7.51386 4.53057C7.38493 4.65936 7.3125 4.83405 7.3125 5.0162V7.80276C7.31474 7.96242 7.34941 8.11998 7.41443 8.26586C7.47944 8.41174 7.57343 8.54291 7.69071 8.65141L9.1606 9.89083Z"
        fill={fillColor}
      />
    </svg>
  );
};

interface ICountdown {
  countdownSize: string;
  startDate: string;
  endDate: string;
  presaleText: string;
  isSaleText: string;
}
const Countdown = (props: ICountdown) => {
  let saleCountdown: NodeJS.Timeout;
  const [timeRemaining, setTimeRemaining] = useState("");
  const [isSaleLive, setisSaleLive] = useState(false);

  const intervalCall = (date: Date) => {
    const liveTimeLeft = date.valueOf() - new Date().valueOf();
    const seconds = Math.floor((liveTimeLeft / 1000) % 60).toString();
    const mins = Math.floor((liveTimeLeft / 1000 / 60) % 60).toString();
    const hours = Math.floor(liveTimeLeft / (1000 * 60 * 60)).toString();
    setTimeRemaining(
      `${hours.length === 1 ? "0" + hours : hours}:${
        mins.length === 1 ? "0" + mins : mins
      }:${seconds.length === 1 ? "0" + seconds : seconds}`
    );
  };

  const calculateTimeRemaining = (timeLeft: number, date: Date) => {
    const days: number = Math.floor(timeLeft / 86400000);
    if (days >= 2) {
      setTimeRemaining(`${days} Days`);
    } else {
      intervalCall(date);
      saleCountdown = setInterval(() => {
        intervalCall(date);
      }, 1000);
    }
  };

  useEffect(() => {
    // Figure out if the sale is live or not
    const currDate = new Date();
    const startDate = new Date(props.startDate);
    const endDate = new Date(props.endDate);
    // If the current date is after the start date (currDate is greater than saleLive), the sale is live
    const saleLive = startDate < currDate;
    if (!saleLive) {
      // Figure out days left
      const timeLeft = startDate.valueOf() - currDate.valueOf();
      calculateTimeRemaining(timeLeft, startDate);
    } else if (currDate < endDate) {
      // The sale is live!!
      setisSaleLive(true);
      const timeLeft = endDate.valueOf() - currDate.valueOf();
      calculateTimeRemaining(timeLeft, endDate);
    }
    return () => {
      setTimeRemaining("");
    };
  }, []);

  return props.countdownSize === "medium" ? (
    <Container>
      <IconWrapper src={CountdownIcon} />
      <CountdownText>
        <CountdownHeadline>{timeRemaining}</CountdownHeadline>
        <CountdownSubheadline>
          {isSaleLive ? props.isSaleText : props.presaleText}
        </CountdownSubheadline>
      </CountdownText>
    </Container>
  ) : props.countdownSize === "small" ? (
    <CountdownTextSmall isSaleLive={isSaleLive}>
      <SmallCountdownIcon isSaleLive={isSaleLive} />
      <CountdownHeadlineSmall>
        {isSaleLive
          ? timeRemaining + " " + props.isSaleText
          : props.presaleText + " " + timeRemaining}
      </CountdownHeadlineSmall>
    </CountdownTextSmall>
  ) : (
    <CountdownTextMicro isSaleLive={isSaleLive}>
      <SmallCountdownIcon isSaleLive={isSaleLive} />
      <CountdownHeadlineMicro>
        {isSaleLive ? props.isSaleText : props.presaleText} {timeRemaining}
      </CountdownHeadlineMicro>
    </CountdownTextMicro>
  );
};

export default Countdown;

const Container = styled.div`
  width: 80%;
  max-width: 180px;
  background: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  padding: 12px;
  margin-bottom: 20px;
`;

const IconWrapper = styled.img`
  width: 60px;
  height: 60px;
  ${media.phablet`
    width: 40px;
    height: 40px;
  `};
`;

const CountdownText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 12px;
`;

const CountdownHeadline = styled.h3`
  font-weight: 700;
  font-size: 25px;
  line-height: 25px;
  color: #505050;
  ${media.phablet`
    font-size: 22px;
  `};
  margin-top: 0;
  margin-bottom: 0;
`;

const CountdownSubheadline = styled.p`
  margin-top: 2px;
  font-size: 14px;
  line-height: 16px;
  font-weight: 600;
  color: #aaa;
  margin-bottom: 0;
`;

const CountdownHeadlineSmall = styled.p`
  font-weight: 400;
  font-size: 13px;
  color: ${theme.colors.grey[700]};
  margin: 0 10px 0 6px;
`;

const CountdownTextSmall = styled.div<IStyledIsSaleLive>`
  background-color: ${(p) =>
    p.isSaleLive
      ? theme.colors.yellow
      : theme.colors
          .skyblue}66; // 66 sets opacity, should move actual color to theme.js
  border-radius: 10px;
  display: inline-flex;

  svg {
    margin-top: 5px;
    margin-left: 6px;
  }
`;

const CountdownTextMicro = styled.div<IStyledIsSaleLive>`
  margin-top: 8px;
  margin-right: auto;

  background-color: ${(p) =>
    p.isSaleLive
      ? theme.colors.yellow
      : theme.colors
          .skyblue}66; // 66 sets opacity, should move actual color to theme.js
  border-radius: 10px;

  display: inline-flex;
  svg {
    margin-top: 5px;
    margin-left: 6px;
    width: 12px;
  }
`;

const CountdownHeadlineMicro = styled.p`
  font-weight: 400;
  font-size: 10px;
  color: ${theme.colors.grey[700]};
  margin: 0 10px 0 6px;
`;
